import type { Child } from '../../api/models';

export type ChildrenState = {
  isLoading: boolean;
  children: Child[];
  error: string | null;
  /** Parent mode only — §4 puts the id in the parent column, never a child's (R0118). */
  errorCorrelationId: string | null;
  switchingTo: string | null;
};

export const isEmpty = (state: ChildrenState): boolean =>
  !state.isLoading && state.error === null && state.children.length === 0;
